// Same pastel palette as the discrepancy audit chips.
const PALETTE = {
  success: { bg: '#E6F4EA', color: '#1E8E3E' },
  warning: { bg: '#FEF3C7', color: '#92400E' },
  error:   { bg: '#FEE2E2', color: '#991B1B' },
  info:    { bg: '#DBEAFE', color: '#1E40AF' },
  default: { bg: '#F3F4F6', color: '#6B7280' },
};

export const getChipSx = (token) => {
  const { bg, color } = PALETTE[token] || PALETTE.default;
  return {
    backgroundColor: bg,
    color,
    fontWeight: 500,
    border: 'none',
    '& .MuiChip-label': { color },
  };
};
